import { render, staticRenderFns } from "./OrderManage.vue?vue&type=template&id=9781a74a&scoped=true&"
import script from "./OrderManage.vue?vue&type=script&lang=js&"
export * from "./OrderManage.vue?vue&type=script&lang=js&"
import style0 from "./OrderManage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OrderManage.vue?vue&type=style&index=1&id=9781a74a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9781a74a",
  null
  
)

export default component.exports